import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import academicModal from "models/academic.modal";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";

const Addacademic = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();
  const location = useLocation();

  const handleSubmitEditFAQ = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("id", parmas.id);

    // You can adjust the header configuration according to your API requirements
    academicModal
      .Editacademic(form)
      .then((response) => {
        helper.sweetalert.toast(response?.data?.message, "success");
        if (
          location.pathname ===
          `/admin/academic/editboard/${parmas?.id}/${parmas?.perentId}`
        ) {
          navigate(`/admin/board/${parmas?.perentId}`);
        } else if (
          location.pathname ===
          `/admin/academic/editclass/${parmas.id}/${parmas?.perentId}`
        ) {
          navigate(`/admin/class/${parmas.perentId}`);
        } else if (
          location.pathname ===
          `/admin/academic/editsubject/${parmas.id}/${
            parmas?.perentId
          }/${"subject"}`
        ) {
          navigate(`/admin/subjectaca/${parmas.perentId}`);
        } else {
          navigate(`/admin/academic`);
        }
        setAddsLoadig(false);

        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const getListDataByid = () => {
    const data = parmas?.id;
    // Assuming '19' is the ID you want to send
    academicModal
      .listbyAcademicAlldatabyid(data)
      .then((response) => {
        setDataList(response?.data?.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  useEffect(() => {
    if (parmas.id != "") {
      getListDataByid();
    }
  }, [parmas.id]);

  // console.log(dataList, "listbyiddata");

  // Check if the current route matches the desired route path
  const shouldRenderComponent =
    location.pathname === `/admin/academic/editacademicsub/${parmas.id}`;
  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">
                  {location.pathname ===
                  `/admin/academic/editboard/${parmas?.id}/${parmas?.perentId}` ? (
                    <span>Edit Board</span>
                  ) : location.pathname ===
                    `/admin/academic/editclass/${parmas?.id}/${parmas?.perentId}` ? (
                    <span>Edit Class</span>
                  ) : location.pathname ===
                    `/admin/academic/editsubject/${parmas?.id}/${
                      parmas?.perentId
                    }/${"subject"}` ? (
                    <span>Edit Subject</span>
                  ) : (
                    <span>Edit Academic</span>
                  )}
                </h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitEditFAQ}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Name</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="name"
                            placeholder="Enter Name"
                            defaultValue={dataList?.name}
                          />
                        </FormGroup>
                      </Col>

                      {parmas.name === "subject" ? null : (
                        <Col md={6}>
                          <FormGroup>
                            <Label for="exampleEmail">Sub-Category Title</Label>
                            <Input
                              id="name"
                              name="title"
                              placeholder="Enter Sub-Category Title"
                              defaultValue={dataList?.title}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ display: "none" }}>
                      {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Parentid</Label>
                          <Input
                            id="parentid"
                            name="parentid"
                            type="number"
                            placeholder="Enter Parentid"
                          />
                        </FormGroup>
                      </Col> */}

                      {/* <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Type</Label>
                          <Input id="forType" name="forType" type="select">
                            <option value="driver">select option</option>
                            <option value="user">Tutor</option>
                            <option value="both">Student</option>
                          </Input>
                        </FormGroup>
                      </Col> */}
                    </Row>

                    <Row>
                    <Col md={6}>
                          <FormGroup>
                            <Label>vacancy Available</Label>
                            <Input
                              type="select"
                              id="name"
                              name="vacancyavailable"
                              placeholder="Enter Sub-Category Title"
                            >
                              <option value="false">False</option>
                              <option value="true">True</option>
                            </Input>
                          </FormGroup>
                        </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="exampleEmail">Icon</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            defaultValue={dataList?.logo}
                            id="name"
                            name="logo"
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        color="secondary"
                        onClick={() => {
                          let newPath = "/admin/academic"; // Default path
                          switch (location.pathname) {
                            case `/admin/academic/editboard/${parmas?.id}/${parmas?.perentId}`:
                              newPath = `/admin/board/${parmas?.id}`;
                              break;
                            case `/admin/academic/editclass/${parmas.id}/${parmas?.perentId}`:
                              newPath = `/admin/class/${parmas?.id}`;
                              break;
                            case `/admin/academic/editsubject/${parmas.id}/${
                              parmas?.perentId
                            }/${"subject"}`:
                              newPath = `/admin/subjectaca/${parmas?.id}`;
                              break;
                            default:
                              newPath = "/admin/academic";
                              break;
                          }
                          navigate(newPath);
                        }}
                      >
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                          style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white"}}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Addacademic;
